import { STORAGE_KEYS } from 'consts';

export const getToken = () => window.localStorage.getItem(STORAGE_KEYS.token);
